import { createPayloadAction } from 'helpers/actionsHelpers'
import { PayloadAction } from 'interfaces/action'
import { City, Location } from 'interfaces/locations'

type SearchPayload = {
  id: string
  query: string
}

export const REGISTER_LOCATIONS_AUTOSUGGEST = 'REGISTER_LOCATIONS_AUTOSUGGEST' as const
type RegisterLocationsAutosuggest = PayloadAction<typeof REGISTER_LOCATIONS_AUTOSUGGEST, string>
export const registerLocationsAutosuggestActionCreator = (id: string): RegisterLocationsAutosuggest =>
  createPayloadAction(REGISTER_LOCATIONS_AUTOSUGGEST, id)

export const DESTROY_LOCATIONS_AUTOSUGGEST = 'DESTROY_LOCATIONS_AUTOSUGGEST' as const
type DestroyLocationsAutosuggest = PayloadAction<typeof DESTROY_LOCATIONS_AUTOSUGGEST, string>
export const destroyLocationsAutosuggestActionCreator = (id: string): DestroyLocationsAutosuggest =>
  createPayloadAction(DESTROY_LOCATIONS_AUTOSUGGEST, id)

export const SEARCH_LOCATIONS = 'SEARCH_LOCATIONS' as const
type SearchLocations = PayloadAction<typeof SEARCH_LOCATIONS, SearchPayload>
export const searchLocationsActionCreator = (id: string, query: string): SearchLocations =>
  createPayloadAction(SEARCH_LOCATIONS, { id, query })

export const SET_LOCATIONS = 'SET_LOCATIONS' as const
type SetLocations = PayloadAction<typeof SET_LOCATIONS, SearchPayload & { locations: Location[] }>
export const setLocationsActionCreator = (locations: Location[], id: string, query: string) =>
  createPayloadAction(SET_LOCATIONS, { locations, id, query })


export const REGISTER_CITIES_AUTOSUGGEST = 'REGISTER_CITIES_AUTOSUGGEST' as const
type RegisterCitiesAutosuggest = PayloadAction<typeof REGISTER_CITIES_AUTOSUGGEST, string>
export const registerCitiesAutosuggestActionCreator = (id: string): RegisterCitiesAutosuggest =>
  createPayloadAction(REGISTER_CITIES_AUTOSUGGEST, id)

export const DESTROY_CITIES_AUTOSUGGEST = 'DESTROY_CITIES_AUTOSUGGEST' as const
type DestroyCitiesAutosuggest = PayloadAction<typeof DESTROY_CITIES_AUTOSUGGEST, string>
export const destroyCitiesAutosuggestActionCreator = (id: string): DestroyCitiesAutosuggest =>
  createPayloadAction(DESTROY_CITIES_AUTOSUGGEST, id)

export const SEARCH_CITIES = 'SEARCH_CITIES' as const
type SearchCities = PayloadAction<typeof SEARCH_CITIES, SearchPayload>
export const searchCitiesActionCreator = (id: string, query: string) =>
  createPayloadAction(SEARCH_CITIES, { id, query })

export const SET_CITIES = 'SET_CITIES' as const
type SetCities = PayloadAction<typeof SET_CITIES, SearchPayload & { cities: City[] }>
export const setCitiesActionCreator = (cities: City[], id: string, query: string): SetCities =>
  createPayloadAction(SET_CITIES, { cities, id, query })

type Action =
  | RegisterLocationsAutosuggest
  | DestroyLocationsAutosuggest
  | SearchLocations
  | SetLocations
  | RegisterCitiesAutosuggest
  | DestroyCitiesAutosuggest
  | SearchCities
  | SetCities

export default Action
